var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutimg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 477.993,
    height: 478,
    viewBox: "0 0 477.993 478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "DSC_9077",
    d: "M477.329,207.282c.777,17.269.9,45.591.239,62.92a265.216,265.216,0,0,1-11.413,62.023,224.281,224.281,0,0,1-30.384,56.167,175.465,175.465,0,0,1-49.176,40.243c-15.954,8.067-41.827,20.435-57.691,27.456a306.594,306.594,0,0,1-60.051,18.165,327.6,327.6,0,0,1-63.577,3.436,138.327,138.327,0,0,1-58.826-20.256c-14.61-10.009-38.242-25.783-52.523-35.045a393.023,393.023,0,0,1-48.967-39.018,131.008,131.008,0,0,1-30.593-53c-4.213-16.94-9.59-44.486-11.951-61.246A333.362,333.362,0,0,1,.682,207.79a279.4,279.4,0,0,1,13.355-60.44A240.622,240.622,0,0,1,44.391,92.8a171.132,171.132,0,0,1,47.8-39.437,409.674,409.674,0,0,0,54.166-34.537A103.671,103.671,0,0,1,204.916,0,576.137,576.137,0,0,1,268.4,7.021c16.94,2.988,45.143,8.335,62.74,11.8a135.34,135.34,0,0,1,55.57,28.114A259,259,0,0,1,426.21,95.6c8.724,14.938,23.483,38.839,32.864,53.568a140.239,140.239,0,0,1,18.314,58.08",
    transform: "translate(-0.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutimg01);
export default __webpack_public_path__ + "static/media/aboutimg01.0a1d7ac9fbdf54352fe52cf82de29210.svg";
export { ForwardRef as ReactComponent };